<template>
    <section class="benefits__section">

      <the-header
        :introDiscoveryTextProp="'Discover More'"
        :introDiscoveryLinkProp='nextPage ? "/registration" : ""'
        :isCycleOnProp='!isCardsCycleDone'
      >
      </the-header>

      <section
        class="wrapper"
        :class="{'cards--disabled': isUserReadyForRegPage}"
      >
        <section>
          <h1
            @mouseover="MX_isZoom(true)"
            @mouseleave="MX_isZoom(false)"
            :class="fadeInText?'fadeInText':''"
          >
            BurgundysCollection:
            <br>
            Exclusive Member Benefits
          </h1>
          <!-- Cards -->
          <div
            class="cards__wrapper"
            :class="{'cards__wrapper--hover': this.isCardsCycleDone}"
          >
            <div
              class="cards__wrapper__item"
              v-for="(card, index) in cards"
              :key="`cards-${index}`"
              :style="{order: orderWidth < 763?card.id:card.orderFlex}"
              :class="{
                'cards__wrapper__item--active': card.active,
                'cards__wrapper__item--before-unactive': card.beforeElemUnactive,
                'cards__wrapper__item--hover': card.hover
              }"
              @click="''"
              @mouseover="cardHover(index)"
              @mouseleave="cardLeave(index)"
            >
              <div class="cards__wrapper__item__number">{{card.cardNumber}}</div>
              <p>{{card.desc}}</p>
            </div>
          </div>
        </section>
      </section>

      <div class="intro__to__registration">
        <p
          @mouseover="takeUserToRegistrationPageText"
          @mouseleave="benefitsToDefault"
        >
          If our values match yours, then register your interest in becoming a member of BurgundysCollection.
        </p>
      </div>

      <section
        class="ring__svg__wrapper"
        :class="{'ring__svg__wrapper--active': !isCardsCycleDone}"
      >
        <svg
          width="282px"
          height="282px"
          viewBox="0 0 282 282"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          :style="`transform: rotate(${9 * rotateSvgArc - 9}deg)`"
        >
          <g id="Chapter1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="BenefitsV5a" transform="translate(-1009.000000, -259.000000)" stroke="#C24E5C">
              <g id="Group-5" transform="translate(970.000000, 220.000000)">
                <circle id="Oval-Copy-7" opacity="0.0954008557" transform="translate(180.000000, 180.000000) rotate(-6.000000) translate(-180.000000, -180.000000) " cx="180" cy="180" r="140"></circle>
                <path d="M180,320 C257.319865,320 320,257.319865 320,180 C320,102.680135 257.319865,40 180,40 C102.680135,40 40,102.680135 40,180" id="Oval-Copy-7" transform="translate(180.000000, 180.000000) scale(-1, 1) rotate(-160.000000) translate(-180.000000, -180.000000) "></path>
              </g>
            </g>
          </g>
        </svg>
      </section>

      <section
        @mouseover="takeUserToRegistrationPage"
        @mouseleave="benefitsToDefault"
        class="benefits__next__page"
        :class="{'benefits__next__page--active': isCardsCycleDone}"
      >
        <next-page
          :nextPageProp="'/registration'"
          :isCycleOnProp='!isCardsCycleDone'
        ></next-page>
      </section>

      <!-- ONLY FOR DEV -->
      <!-- <div style="position: absolute; color: black; top: 10px; right: 20px; font-size: 22px;">
        <router-link to="/registration">NEXT PAGE</router-link>
      </div> -->

    </section>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import NextPage from '@/components/VNextPage.vue'
import { isZooming } from '../mixins/isZooming'

export default {
  name: 'Benefits',
  components: {
    'the-header': TheHeader,
    'next-page': NextPage
  },
  mixins: [
    isZooming
  ],
  data () {
    return {
      firstCardLoad: true,
      cardsBeforeElem: 0,
      cardsNextElem: 1,
      isCardsCycleDone: false,
      nextPage: '',
      isUserReadyForRegPage: false,
      rotateSvgArc: 0,
      fadeInText: false,
      orderWidth: 763,
      cards: [
        {
          id: 1,
          desc: 'Access to exclusive allocations directly prepared and priced by the winemaker.',
          orderFlex: 2,
          active: false,
          beforeElemUnactive: false,
          cardNumber: 1,
          hover: false
        },
        {
          id: 2,
          desc: 'A personal invitation to discover the new vintage with the grower.',
          orderFlex: 5,
          active: false,
          beforeElemUnactive: false,
          cardNumber: 2,
          hover: false
        },
        {
          id: 3,
          desc: 'A guarantee of perfect and authentic provenance signed by the Domain.',
          orderFlex: 4,
          active: false,
          beforeElemUnactive: false,
          cardNumber: 3,
          hover: false
        },
        {
          id: 4,
          desc: 'Complimentary, insured and unlimited storage in Burgundy.',
          orderFlex: 7,
          active: false,
          beforeElemUnactive: false,
          cardNumber: 4,
          hover: false
        },
        {
          id: 5,
          desc: 'Exclusive offers of limited editions, special formats and back vintages.',
          orderFlex: 0,
          active: false,
          beforeElemUnactive: false,
          cardNumber: 5,
          hover: false
        },
        {
          id: 6,
          desc: 'Access to a partial or total release of your bottles at any time (after three years minimum cellaring).',
          orderFlex: 3,
          active: false,
          beforeElemUnactive: false,
          cardNumber: 6,
          hover: false
        },
        {
          id: 7,
          desc: 'Independent literature on Burgundy and Burgundies.',
          orderFlex: 6,
          active: false,
          beforeElemUnactive: false,
          cardNumber: 7,
          hover: false
        },
        {
          id: 8,
          desc: 'The guarantee that the wines are stored in perfect conditions throughout their life in our cellars in Burgundy.',
          orderFlex: 1,
          active: false,
          beforeElemUnactive: false,
          cardNumber: 8,
          hover: false
        }
      ]
    }
  },
  mounted () {
    this.orderWidth = window.innerWidth
    if (this.firstCardLoad) {
      if (window.innerWidth < 763) {
        this.nextPage = '/registration'
        this.isCardsCycleDone = true
        this.$store.commit('updateCursorType', 1)
      } else {
        // this.clearCardsInterval = setInterval(() => this.cycleCards(), 6000)
        this.$store.commit('updateCursorType', 7)
        setTimeout(() => {
          this.cycleCards()
          this.clearCardsInterval = setInterval(() => this.cycleCards(), 6000)
          this.$store.commit('updateCursorType', 5)
        }, 3000)
      }
    }
  },
  methods: {
    cardHover (index) {
      this.cards[index].hover = true
      this.MX_isZoom(true)
    },
    cardLeave (index) {
      this.cards[index].hover = false
      this.MX_isZoom(false)
    },
    cycleCards () {
      for (let i = 1; i <= this.cards.length; i++) {
        // Animate from 0 to 1.5 the first element in the row
        this.cards[this.cardsBeforeElem].active = true
        this.cardsBeforeElem++
        // Animate back from 1.5 to 1.0 the before first element in the row
        setTimeout(() => {
          this.cards[this.cardsNextElem - 1].beforeElemUnactive = true
          this.cardsNextElem++
          // Rotate the SVG arc as cards as showing up
          this.rotateSvgArc = this.cards[this.cardsBeforeElem - 1].id
          // console.log(this.rotateSvgArc)
          // Only for first card
          this.firstCardLoad = false
        }, 5000)
        // At the end of the Array:
        if (this.cardsBeforeElem === 5) {
          this.fadeInText = true
        }
        if (this.cardsBeforeElem === 8) {
          // 1. stop the interval
          clearInterval(this.clearCardsInterval)
          // 2. load header link
          this.nextPage = '/registration'
          // 3. after eigth card animation set the cycle to done
          setTimeout(() => {
            this.isCardsCycleDone = true
            this.$store.commit('updateCursorType', 1)
          }, 5300)
          return
        }
        break
      }
    },
    takeUserToRegistrationPage () {
      this.isUserReadyForRegPage = true
    },
    takeUserToRegistrationPageText () {
      if (this.isCardsCycleDone) this.isUserReadyForRegPage = true
    },
    benefitsToDefault () {
      this.isUserReadyForRegPage = false
    }
  }
}
</script>
